import { AUTH_COOKIES } from '../constants/authCookies';
import type { AuthTokens } from '../types/transport';

/** The session tokens from a `Cookie` header (`document.cookie` or a request's), or `null` without an access token. */
export function parseAuthCookies(cookieHeader: string): AuthTokens | null {
    const values = new Map<string, string>();

    for (const part of cookieHeader.split(';')) {
        const separator = part.indexOf('=');
        if (separator === -1) {
            continue;
        }
        const name = part.slice(0, separator).trim();
        // The first cookie with a name wins, like in the browser's own order (more specific path / domain first).
        if (!values.has(name)) {
            values.set(name, part.slice(separator + 1).trim());
        }
    }

    const accessToken = decode(values.get(AUTH_COOKIES.ACCESS));
    if (!accessToken) {
        return null;
    }

    return { access_token: accessToken, refresh_token: decode(values.get(AUTH_COOKIES.REFRESH)) ?? '' };
}

function decode(value: string | undefined): string | undefined {
    if (!value) {
        return undefined;
    }
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}
